module.exports = __webpack_public_path__ + "img/Logo_nova_branca.cb05149e.png";